



// import React, { useState, useEffect } from 'react';
// import './HomeSliderTwo.css';

// const HomeSliderTwo = () => {
//   const [currentIndex, setCurrentIndex] = useState(0);
//   const [slidesToShow, setSlidesToShow] = useState(1); // Default to mobile view settings

//   const slides = [
//     { image: './images/collections/blazer1.jpg' },
//     { image: './images/collections/blazer2.jpg' },
//     { image: './images/collections/blazer3.jpg' },
//     { image: './images/collections/blazer4.jpg' },
//     { image: './images/collections/blazer5.jpg' },
//     { image: './images/collections/blazer6.jpg' },
//     { image: './images/collections/blazer1.jpg' },
//     { image: './images/collections/blazer2.jpg' }
//   ];

//   const totalSlides = slides.length;

//   useEffect(() => {
//     // Adjust the number of slides shown based on screen width
//     const updateSlidesToShow = () => {
//       if (window.innerWidth < 768) {
//         setSlidesToShow(1); // Mobile view shows 1 slide
//       } else {
//         setSlidesToShow(4); // Desktop view shows 3 slides
//       }
//     };

//     updateSlidesToShow(); // Initial check
//     window.addEventListener('resize', updateSlidesToShow); // Adjust on resize

//     return () => window.removeEventListener('resize', updateSlidesToShow);
//   }, []);

//   const moveSlider = (direction) => {
//     let newIndex = currentIndex + direction;

//     // Prevent moving past the first or last slide
//     if (newIndex < 0) newIndex = 0;
//     if (newIndex > totalSlides - slidesToShow) newIndex = totalSlides - slidesToShow;

//     setCurrentIndex(newIndex);
//   };

//   const offset = -(currentIndex * (100 / slidesToShow));

//   return (
//     <div className="slider-container">
//       <button
//         className="slider-btn prev-btn"
//         onClick={() => moveSlider(-1)}
//         disabled={currentIndex === 0} // Disable button at the start
//       >
//         &#10094;
//       </button>
//       <div className="slider-track" style={{ transform: `translateX(${offset}%)` }}>
//         {slides.map((product, index) => (
//           <div className="slide" key={index} style={{ width: `${100 / slidesToShow}%` }}>
//             <img src={product.image} alt={`Slide ${index}`} className="slide-image" />
//           </div>
//         ))}
//       </div>
//       <button
//         className="slider-btn next-btn"
//         onClick={() => moveSlider(1)}
//         disabled={currentIndex >= totalSlides - slidesToShow} // Disable button at the end
//       >
//         &#10095;
//       </button>
//     </div>
//   );
// };

// export default HomeSliderTwo;
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './HomeSliderTwo.css';



const HomeSliderTwo = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [slidesToShow, setSlidesToShow] = useState(1); // Default to mobile view settings
  const [isMobile, setIsMobile] = useState(window.innerWidth < 450); // Track if it's mobile view

  const navigate = useNavigate(); // Initialize navigate hook
  const handleRent = (productId) => {
    console.log("Navigating with productId:", productId); // Debugging step
    navigate('/productpreview', { state: { productId } }); // Pass productId to preview page
  };
  const slides = [
    { image: './images/collections/h29.jpg', eventName: 'Jodhpuri Suits',id:"678a1ea4f70a6e0d44ffddaa" },
    { image: './images/collections/h22.jpg', eventName: 'Suits & Tuxedos',id:"678a14c1f70a6e0d44ffcd8d" },
    { image: './images/collections/h23.jpg', eventName: 'Blazers' ,id:"678a18f6f70a6e0d44ffd210"},
    { image: './images/collections/h24.jpg', eventName: 'Ethnic Jackets & Kurta Pyjama',id:"678a29c1f70a6e0d440021d0" },
    { image: './images/collections/h25.jpg', eventName: 'Indowestern & Sherwani',id:"678a2081f70a6e0d44ffe368" },
    { image: './images/collections/h26.jpg', eventName: 'Jodhpuri Suits',id:"678a1a63f70a6e0d44ffd5d7" },
    { image: './images/collections/h27.jpg', eventName: 'Suits & Tuxedos',id:"678a1d64f70a6e0d44ffdc95" },
    { image: './images/collections/h28.jpg', eventName: 'Blazers',id:"678a198ff70a6e0d44ffd261" }
  ];

  const totalSlides = slides.length;

  useEffect(() => {
    // Adjust the view based on screen width (for mobile view vs desktop view)
    const updateIsMobile = () => {
      if (window.innerWidth < 450) {
        setSlidesToShow(1); // Mobile view shows 1 slide
        setIsMobile(true); // Set to mobile view
      } else {
        setSlidesToShow(4); // Desktop view shows 4 slides
        setIsMobile(false); // Set to desktop view
      }
    };

    updateIsMobile(); // Initial check
    window.addEventListener('resize', updateIsMobile); // Adjust on resize

    return () => window.removeEventListener('resize', updateIsMobile);
  }, []);

  const moveSlider = (direction) => {
    let newIndex = currentIndex + direction;

    // Prevent moving past the first or last slide
    if (newIndex < 0) newIndex = 0;
    if (newIndex > totalSlides - slidesToShow) newIndex = totalSlides - slidesToShow;

    setCurrentIndex(newIndex);
  };

  // Apply 3% increase on mobile view offset
  const offset = isMobile
    ? -((currentIndex * (100 / slidesToShow)) * 1.03)  // Mobile view with 3% increase
    : -(currentIndex * (100 / slidesToShow));          // Desktop view with normal offset

  // Function to handle clicking on a slide
  // const handleSlideClick = (style) => {
  //   // Navigate to the products page, passing the selected style as state
  //   navigate("/products", { state: { selectedStyle: style } });
  // };

  return (
    <div className="slider-container">
      <button
        className="slider-btn prev-btn"
        onClick={() => moveSlider(-1)}
        disabled={currentIndex === 0} // Disable button at the start
      >
        &#10094;
      </button>
      <div className="slider-track" style={{ transform: `translateX(${offset}%)` }}>
        {slides.map((product, index) => (
          <div className="slide" key={index} style={{ width: `${100 / slidesToShow}%` }}> {/* Adjust width based on slidesToShow */}
            {/* Add click handler to the image */}
            <div>
              <img src={product.image} alt={`Slide ${index}`} className="slide-image" onClick={() => handleRent(product.id)}/>
            </div>
          </div>
        ))}
      </div>
      <button
        className="slider-btn next-btn"
        onClick={() => moveSlider(1)}
        disabled={currentIndex >= totalSlides - slidesToShow} // Disable button at the end
      >
        &#10095;
      </button>
    </div>
  );
};

export default HomeSliderTwo;
